import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from './DialogModal';
import DatePicker from '../Parts/DatePicker';
import Button from '../Parts/Button';
import moment from 'moment';

const styles = () => ({
  contentContainer: {
    margin: 0,
    padding: 0,
    overflowY: 'auto',
    textAlign: 'left',
  },

  dialogContent: {
    margin: '30px 25px',
  },

  buttonContainer: {
    marginTop: '20px',
  }
});

class TermRangeDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: this.props.isOpen,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
    }
  }

  handleClose = () => {
    this.setState({ isOpen: false });
    this.props.toggleDialog();
  };

  handleDecide = () => {
    this.setState({ isOpen: false });
    this.props.toggleDialog({
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    });
  };

  changeDate = (startDate, endDate) => {
    this.setState({
      startDate: startDate,
      endDate: endDate,
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <DialogModal
        classes={{ contentContainer: classes.contentContainer }}
        open={this.props.isOpen}
        maxWidth="md"
        onClose={this.handleClose}
        title="期間指定"
      >
        <div className={classes.dialogContent}>
          <DatePicker
            isRange={true}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            selectMaxDate={new Date()}
            handleChange={this.changeDate}
          />
          <div className={classes.buttonContainer}>
            <Button
              text="確定"
              handleClickButton={this.handleDecide}
              size="small"
              fullWidth={true}
              style={{ height: '36px' }}
            >
            </Button>
          </div>
        </div>
      </DialogModal>
    );
  }
}

const defaultStartMonthBefore = 3;
TermRangeDialog.defaultProps = {
  startDate: moment().add(-defaultStartMonthBefore, 'month').toDate(),
  endDate: moment().toDate(),
}

TermRangeDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TermRangeDialog);



// WEBPACK FOOTER //
// ./src/components/common/TermRangeDialog.jsx